<template>
    <v-dialog v-model="showDialog"
              class="idea-dialog"
              min-width="600"
              transition="dialog-bottom-transition"
              width="auto">
        <v-card class="date-time-form text-primary ma-0">
            <v-card-title>
                {{ idea ? "Редактирование идеи" : "Создание идеи" }}
            </v-card-title>

            <v-card-text class="pa-4 py-0">
                <v-text-field class="mt-0 mb-1"
                              label="Название"
                              v-model.trim="name" />

                <v-textarea label="Текст"
                            class="mt-5 mt-sm-5 mt-md-0"
                            auto-grow
                            rows="3"
                            v-model.trim="text"></v-textarea>
            </v-card-text>

            <v-card-actions>
                <v-spacer />
                <v-btn color="secondary"
                       variant="elevated"
                       @click="$emit('hide')">Отменить</v-btn>
                <v-btn color="primary"
                       variant="elevated"
                       :disabled="!name"
                       @click="save">Сохранить</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: {
            idea: Object
        },

        emits: ["hide"],

        data() {
            return {
                showDialog: true,

                name: null,
                text: null
            };
        },

        created() {
            if (this.idea) {
                this.name = this.idea.name;
                this.text = this.idea.text;
            }           
        },

        watch: {
            showDialog(newValue) {
                if (newValue === false) {
                    this.$emit("hide");
                }
            }
        },

        methods: {
            save() {
                const idea = {
                    id: this.idea ? this.idea.id : 0,
                    name: this.name,
                    text: this.text
                };

                const methodName = this.idea ? "editIdea" : "createIdea";

                this.$store.dispatch(methodName, idea)
                    .then(() => {
                        this.$store.dispatch("loadIdeas");
                        this.$emit("hide");
                    });
            }
        }
    };
</script>